import*as React from"react";export const QueryBuilderStateContext=/*#__PURE__*/React.createContext(null);